module.exports = __webpack_public_path__ + "static/media/TitilliumWeb-LightItalic.d2749e83.ttf";